import { Tooltip } from '#app/components/Tooltip/Tooltip.js';
import {
  Container,
  CustomAccessoryContainer,
  HintDot,
  Tab,
} from './NavigationTabs.styles.js';
import { type NavigationTabsProps } from './types.js';
import { ChevronRightIcon } from '@contra/icons/icons';
import { Fragment } from 'react';

export const NavigationTabs = <T extends string>({
  activeTabId,
  className,
  customAccessory,
  designProps = {},
  onTabClick,
  tabs,
}: NavigationTabsProps<T>) => {
  const isLast = (index: number) => index === tabs.length - 1;

  return (
    <Container
      $hasBottomBorder={designProps.hasBottomBorder}
      $hasDividers={designProps.hasDividers}
      $hasTopBorder={designProps.hasTopBorder}
      className={className}
    >
      {tabs.map((tab, currentTabIndex) => {
        const tabContent = (
          <Tab
            $isActive={tab.id === activeTabId}
            aria-disabled={tab.isDisabled}
            aria-label={`pill-tab-${tab.label}`}
            disabled={tab.isDisabled}
            onClick={tab.isDisabled ? undefined : () => onTabClick(tab.id)}
          >
            {tab.iconPosition === 'left' ? tab.icon : null}
            {tab.label}
            {tab.iconPosition === 'left' ? null : tab.icon}
            {tab.count === null ? null : <span>{tab.count}</span>}
            {tab.showUnreadIndicator ? <HintDot /> : null}
          </Tab>
        );

        return (
          <Fragment key={tab.id}>
            {tab.tooltip ? (
              <Tooltip
                content={tab.tooltip}
                placement="top"
              >
                {tabContent}
              </Tooltip>
            ) : (
              tabContent
            )}
            {designProps.hasDividers ? (
              tab.dividerIcon ? (
                tab.dividerIcon
              ) : isLast(currentTabIndex) ? null : (
                <ChevronRightIcon size={16} />
              )
            ) : null}
          </Fragment>
        );
      })}

      {customAccessory ? (
        <CustomAccessoryContainer>{customAccessory}</CustomAccessoryContainer>
      ) : null}
    </Container>
  );
};
